import React from 'react'
import {
  FormDashboardLabel as Label,
} from '../'
import Select from 'react-select'
import { useProvinces } from '../../features/provinces/hook'

const ProvinceSelect = ({ defaultValue, onChange }) => {
  const { options }  = useProvinces()

  return (
    <>
      <Label>Province</Label>
      <Select
        className="text-sm"
        options={options}
        placeholder="Choose Province"
        defaultValue={defaultValue}
        onChange={onChange}
      />
    </>
  )
}

export { ProvinceSelect }
